import { render, staticRenderFns } from "./HeaderBaseLink.vue?vue&type=template&id=51c657a5&"
import script from "./HeaderBaseLink.vue?vue&type=script&lang=ts&"
export * from "./HeaderBaseLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports